import { memo } from 'react';
import { Button } from '@iq/react-components';

import ErrorBoundary from '../ErrorBoundary';
import BigModal from './BigModal';
import './BigModal.scss';

const ErrorComponent = memo(({ onReload, retries, ...rest }) => {
  const reloader = retries > 0 ? () => globalThis.location.reload() : onReload;
  const reloadCta = retries > 0 ? 'Reload Page' : 'Reload';
  return (
    <BigModal {...rest}>
      <div className="bound-error">
        <div>
          <p>Something went wrong</p>
          <Button
            onClick={reloader}
            activity="secondary"
            type="button"
          >
            {reloadCta}
          </Button>
        </div>
      </div>
    </BigModal>
  );
});

const BoundBigModal = (properties) => (
  <ErrorBoundary
    ErrorComponent={ErrorComponent}
    {...properties}
  >
    <BigModal {...properties} />
  </ErrorBoundary>
);

export default BoundBigModal;
